export const formatLanguageCode = (langCode: string): string => {
  const parts = langCode.split("-");

  const formattedCode =
    parts.length > 1
      ? `${parts[0].toLowerCase()}-${parts[1].length === 2 ? parts[1].toUpperCase() : parts[1]}`
      : parts[0];

  return formattedCode;
};

/**
 * Whether the list holds the language code. Case is ignored because the API
 * sends codes upper cased, such as ES-ES for es-ES.
 */
export const includesLanguage = (
  languages: string[],
  language: string
): boolean =>
  languages.some((code) => code.toLowerCase() === language.toLowerCase());
